import { createStore, compose } from "redux";
import combine from "./reducers/combine"; // Make sure this path is correct

// Enable Redux DevTools if available, otherwise fallback to the default compose
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Create the Redux store
const store = createStore(combine, composeEnhancers());

export default store;
